import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface CoupeSelectedIconProps {
  color?: Color;
}

const CoupeSelectedIcon: React.FC<CoupeSelectedIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M64.5599 29.01C64.5599 29.01 69.13 28.54 70 28.36C70.8692 28.0494 71.6251 27.4851 72.1699 26.74C72.4419 25.6712 72.4862 24.5571 72.2999 23.47C72.1499 23.04 71.6899 22.99 71.5499 22.62C71.4099 22.25 71.19 19.3 71.15 18.76C71.0024 18.0661 70.6297 17.4404 70.09 16.9801C69.5799 16.5701 64.8999 16.1201 64.4299 15.9801C63.9599 15.8401 55.7 13.6601 53.1 13.0401C50.5 12.4201 39.88 12.04 36.6 12.64C32.2866 13.55 28.154 15.1685 24.37 17.43C15.37 17.71 9.51994 19.38 8.82994 19.65C8.13994 19.92 5.12995 21.34 4.58995 23.36C4.10995 25.21 4.53001 28.92 4.90001 29.02C5.27001 29.12 10.22 29.84 10.22 29.84L64.5599 29.01Z"
      fill={color}
      stroke={color}
      strokeWidth="0.75"
    />
    <path d="M24.59 28.59L50.25 28.17" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
    <path
      d="M26.9 18.27C31.39 18.11 56.72 17.37 61.41 17.2"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path d="M48.22 13.51L47.46 17.63" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
    <path
      d="M12.4399 21.15C11.973 21.6626 11.5515 22.2146 11.1799 22.8C11.1512 22.8457 11.1115 22.8835 11.0643 22.9097C11.0171 22.9359 10.964 22.9498 10.91 22.95C10.07 22.95 7.90992 23.07 7.80992 22.84C7.75982 22.6543 7.75932 22.4586 7.80845 22.2726C7.85759 22.0866 7.95466 21.9168 8.08995 21.78C8.37995 21.6 9.08999 20.94 12.26 20.78C12.3069 20.768 12.3563 20.7726 12.4003 20.7929C12.4442 20.8132 12.4798 20.8481 12.501 20.8916C12.5221 20.9351 12.5276 20.9846 12.5165 21.0317C12.5054 21.0787 12.4783 21.1205 12.4399 21.15Z"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M71.76 18.76H71.15C71.15 18.76 68.9099 18.76 68.6899 18.82C68.4699 18.88 68.11 18.96 68.25 19.3C68.393 19.7478 68.5736 20.1827 68.7899 20.6C68.8157 20.6378 68.85 20.6692 68.8898 20.6917C68.9297 20.7142 68.9743 20.7274 69.02 20.73C69.7652 20.7354 70.509 20.665 71.2399 20.52L71.9599 20.35"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M22.4101 27.3C22.4705 28.3216 22.2257 29.338 21.7069 30.2202C21.1882 31.1023 20.4188 31.8102 19.4967 32.254C18.5746 32.6978 17.5414 32.8574 16.5284 32.7125C15.5153 32.5676 14.5682 32.1248 13.8075 31.4403C13.0468 30.7558 12.5068 29.8605 12.2561 28.8683C12.0055 27.8761 12.0556 26.8318 12.3999 25.8682C12.7443 24.9045 13.3673 24.065 14.19 23.4564C15.0126 22.8477 15.9978 22.4974 17.0201 22.45C18.2684 22.399 19.4943 22.7923 20.48 23.56"
      fill={color}
    />
    <path
      d="M22.4101 27.3C22.4705 28.3216 22.2257 29.338 21.7069 30.2202C21.1882 31.1023 20.4189 31.8102 19.4967 32.254C18.5746 32.6978 17.5414 32.8574 16.5284 32.7125C15.5153 32.5676 14.5683 32.1248 13.8075 31.4403C13.0468 30.7558 12.5068 29.8605 12.2561 28.8683C12.0055 27.8761 12.0556 26.8318 12.3999 25.8682C12.7443 24.9045 13.3673 24.065 14.19 23.4564C15.0126 22.8477 15.9978 22.4974 17.0201 22.45C18.2684 22.399 19.4943 22.7923 20.48 23.56"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M63.11 27.32C63.1702 28.3411 62.9256 29.3572 62.4072 30.239C61.8888 31.1208 61.1201 31.8286 60.1986 32.2726C59.2771 32.7166 58.2443 32.8767 57.2317 32.7325C56.219 32.5883 55.272 32.1465 54.511 31.463C53.7499 30.7795 53.2093 29.8852 52.9576 28.8938C52.7059 27.9023 52.7546 26.8584 53.0974 25.8947C53.4402 24.9309 54.0617 24.0908 54.883 23.481C55.7043 22.8713 56.6882 22.5194 57.7099 22.4701C58.9586 22.4164 60.1854 22.81 61.1699 23.58"
      fill={color}
    />
    <path
      d="M63.11 27.32C63.1702 28.3411 62.9256 29.3572 62.4072 30.239C61.8888 31.1208 61.1201 31.8286 60.1986 32.2726C59.2771 32.7166 58.2443 32.8767 57.2317 32.7325C56.219 32.5883 55.272 32.1465 54.511 31.463C53.7499 30.7795 53.2093 29.8852 52.9576 28.8938C52.7059 27.9023 52.7546 26.8584 53.0974 25.8947C53.4402 24.9309 54.0617 24.0908 54.883 23.481C55.7043 22.8713 56.6882 22.5194 57.7099 22.4701C58.9586 22.4164 60.1854 22.81 61.1699 23.58"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
  </svg>
);

export default CoupeSelectedIcon;
